import { FC, useState } from "react";

import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormMaskedTextField,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
interface IRemittanceYearToDateFieldsLeftPanel extends ITest {
	yearsDDLItems: any,
	onYearSelectionChangeHandler: (params: any) => void;

}
export const RemittanceYearToDateFieldsLeftPanel: FC<
	IRemittanceYearToDateFieldsLeftPanel
> = ({ yearsDDLItems, onYearSelectionChangeHandler }) => {

	return (
		<>
			<EnhancedDropDownRHFWithLabel
				selectName="year"
				testId={`year`}
				label="Year"
				labelPosition={LabelPosition.Top}
				items={yearsDDLItems ?? []}
				onSelectionChangeHandler={onYearSelectionChangeHandler}
			/>
			<RHookFormNumberFieldWithLabel
				id="remittedToCra"
				testId={`remitted-To-CRA`}
				label="Remitted to CRA"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormNumberFieldWithLabel
				id="wsibRemitted"
				testId={`wsib-remitted`}
				label="WSIB Remitted"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormNumberFieldWithLabel
				id="ehtRemitted"
				testId={`eht-remitted`}
				label="EHT Remitted"
				labelPosition={LabelPosition.Top}

			/>
			<RHookFormNumberFieldWithLabel
				id="ehtBritishColumbia"
				testId={`eht-british-columbia`}
				label="EHT British Columbia"
				labelPosition={LabelPosition.Top}

			/>
		</>
	);
};
